import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import {
  AuthValidator,
  AuthProvider,
  ExamCardExpiredProvider,
  PreviewAuthProvider,
} from './providers';
import {
  ErrorRoute,
  ExamPreviewRoutes,
  ExamRoutes,
  HomeRoute,
  LoginRoute,
  PATHS,
  ProtectedRoute,
  SessionExpiredRoute,
  ExamResultRoute,
} from './routes';
import { FontSizeProvider } from './routes/exam/contexts/FontSizeContext';

const NonExistentRoute = {
  path: '*',
  element: <Navigate to={PATHS.Home} />,
};

const ProtectedExamRoutes = {
  path: '/',
  element: (
    <FontSizeProvider>
      <ExamCardExpiredProvider>
        <ProtectedRoute />
      </ExamCardExpiredProvider>
    </FontSizeProvider>
  ),
  children: [...ExamRoutes, NonExistentRoute, ErrorRoute, SessionExpiredRoute],
};

const AuthExamRoutes = {
  path: '/',
  element: (
    <AuthProvider>
      <AuthValidator />
    </AuthProvider>
  ),
  children: [LoginRoute, HomeRoute, ProtectedExamRoutes, ExamResultRoute],
};

const ProtectedExamPreviewRoutes = {
  path: '/',
  element: (
    <FontSizeProvider>
      <ProtectedRoute />
    </FontSizeProvider>
  ),
  children: [...ExamPreviewRoutes, NonExistentRoute, ErrorRoute, SessionExpiredRoute],
};

const AuthPreviewRoutes = {
  path: '/',
  element: (
    <PreviewAuthProvider>
      <Outlet />
    </PreviewAuthProvider>
  ),
  children: [ProtectedExamPreviewRoutes],
};

const router = createBrowserRouter([AuthExamRoutes, AuthPreviewRoutes]);

export default router;
